export const appointments = [
    {
      title: 'Monthly Summit Meet',
      startDate: new Date(2021, 2, 14, 16, 30),
      endDate: new Date(2021, 2, 14, 20),
      id: 0,
      location: 'Summit Racing',
    },
  ];
  